module.exports = __webpack_public_path__ + "static/performance5-5c1e0398d3bb41c73f4e9ef12a7a9320.jpg";